import {
  Accordion,
  AccordionBody,
  AccordionHeader,
} from "@material-tailwind/react";
import numeral from "numeral";
import { useEffect, useMemo, useState } from "react";
import {
  CardFinancialResult
} from "../../../components/card/CardMain";
import { InfoDrawer } from "../../../components/drawer/InfoDrawer";
import { ImageMain } from "../../../components/img/Img.Main";
import { calculateBasicLiquidityRatio } from "../../../functions/Balance/basic-liquidity-ratio";
import { calculateDebtToTotalAssets } from "../../../functions/Balance/debt-to-total-assets";
import {
  sumCapitalInvest,
  sumDebtInvest,
} from "../../../functions/Balance/sumProperty";
import { SumDebtPersonalValue } from "../../../functions/Balance/sumValueBalance";
import {
  STYLE_BOXCAL_ETC,
  STYLE_INFODRAWER_ETC,
  STYLE_SPACE_SUM_NETFLOW,
  STYLE_TITLE_SUM_NETFLOW
} from "../../../utils/useStyle";
import { PopupBalanceMain } from "../styles/PopupBalance";

// สรุปอัตราส่วนทางการเงินจาก owner กลางของแต่ละสูตร แล้วใช้ผลเดียวกันกับการ์ด Popup และรายละเอียดคำนวณ
const SumFinancial = ({
  balanceData,
  setBalanceData,
  formBL,
  open,
  onClick,
  openPopupIncome,
  setOpenPopupIncome,
  openPopupOutcome,
  setOpenPopupOutcome,
  openPopupProperty,
  setOpenPopupProperty,
  openPopupDebtToAsset,
  setOpenPopupDebtToAsset,
  openPopupDebtToSalary,
  setOpenPopupDebtToSalary,
  openPopupConservation,
  setOpenPopupConservation,
  openPopupInvest,
  setOpenPopupInvest,
  openInfoSumFinancial,
  setOpenInfoSumFinancial,
  addInvest = [],
  ReturnInsurance: ReturnInsuranceProp,
}) => {
  // คำนวณ ReturnInsurance เอง (เหมือน VIPropertyPropotion) เพื่อให้ค่าตรงกัน
  const [ReturnInsurance, setReturnInsurance] = useState([]);
  useEffect(() => {
    if (balanceData) {
      let tempInsuranceReturn = balanceData?.expenses_fixed_list
        ?.filter(
          (item) => item.options_expenses_fixed === "expenses_insuarant_life"
        )
        ?.map((item) => item.expenses_insuarant_lifes)
        ?.flat();

      let tempBalanceData = {};
      if (
        balanceData?.property_invest_list
          ?.map((item) => item.options_property_invest_title)
          .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
        tempInsuranceReturn?.length === 0
      ) {
        let tempNameList = balanceData?.property_invest_list
          .find(
            (item) =>
              item?.options_property_invest_title ===
              "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
          )
          ?.invest_other_lists?.filter((item) => item !== null)
          ?.map((item) => item?.title);

        let tempInvestList = balanceData?.property_invest_list?.map((item) => {
          if (item?.invest_other_lists) {
            let tempData = tempInsuranceReturn
              ?.map((item2) => {
                if (!tempNameList?.includes(item2.title))
                  return {
                    amount: item2?.more_details?.policy_surrender_value,
                    created: item2.created,
                    reward_amount_per_year: item?.reward_amount_per_year || 1,
                    target_invest: {},
                    title: item2.title,
                    editable: false,
                  };
              })
              .filter((item) => item !== undefined);
            return {
              ...item,
              invest_other_lists: [...item.invest_other_lists, ...tempData],
            };
          }
          return item;
        });
        tempBalanceData = tempInvestList;
      } else {
        let tempInvestList = tempInsuranceReturn?.map((item) => {
          return {
            amount: item?.more_details?.policy_surrender_value,
            created: item.created,
            reward_amount_per_year: item?.reward_amount_per_year || 1,
            target_invest: item?.target_invest || {},
            title: item.title,
            editable: true,
          };
        });
        tempBalanceData = tempInvestList;
      }
      setReturnInsurance(tempBalanceData);
    }
  }, [balanceData]);

  //======================================== รายรับ ========================================//
  const countPositiveValues = () => {
    const positiveValues = [
      formBL?.sum_salary_peryear,
      formBL?.sum_interest_peryear,
      formBL?.sum_other_income,
    ]?.filter((value) => value > 0);
    return positiveValues?.length;
  };
  const getResult = () => {
    const numPositiveValues = countPositiveValues();
    if (numPositiveValues === 1) {
      return "normal";
    } else if (numPositiveValues > 1) {
      return "good";
    } else {
      return "false";
    }
  };
  const checkIncomeTitle = () => {
    const status = getResult();
    if (status === "normal") {
      return (
        <div className=" bg-yellowopacity text-mainyellow  px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          พอใช้
        </div>
      );
    }
    if (status === "good") {
      return (
        <div className="bg-greenopacity text-maingreen px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          ยอดเยี่ยม
        </div>
      );
    }
  };
  const checkIncomeIcon = () => {
    const status = getResult();
    if (status === "normal") {
      return "../images/medium_finance.svg";
    }
    if (status === "good") {
      return "../images/happy_finance.svg";
    }
  };

  const checkIncomeSubtitle = () => {
    const status = getResult();
    if (status === "normal") {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-mainyellow">
          คุณมีช่องทางรายรับไม่หลากหลาย
        </div>
      );
    }
    if (status === "good") {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-maingreen">
          คุณมีรายรับหลากหลายช่องทาง
        </div>
      );
    }
  };
  const checkIncomeDes = () => {
    const status = getResult();
    if (status === "normal") {
      return (
        <div>
          คุณน่าจะเพิ่มช่องทางการหารายรับ
          <div>
            เช่น การลงทุนให้ได้เงินปันผล, การออมเงินเพื่อดอกเบี้ย
            หรือเพิ่มอาชีพที่ 2 เพื่อช่วยให้คุณบรรลุเป้าหมายทางการเงิน
          </div>
        </div>
      );
    }
    if (status === "good") {
      return (
        <div>
          <div>คุณมีรายรับมากกว่า 1 ช่องทาง</div>
          รายรับเหล่านี้สามารถช่วยให้คุณบรรลุเป้าหมายทางการเงินได้แน่นอน
        </div>
      );
    }
  };

  //======================================== รายจ่าย ========================================//
  const checkResultExpenses = () => {
    // รายรับ
    const salaryValue = formBL?.salary_propotion ? formBL?.salary_propotion : 0;
    // ค่าใช้จ่ายการออมและลงทุน
    const sumExpensesInvestSaving = formBL?.sum_expenses_invest_saving
      ? formBL?.sum_expenses_invest_saving
      : 0;
    // รายจ่ายที่ไม่รวมค่าใช้จ่ายเพื่อการออม
    const expenseValue = formBL?.expenses_propotion
      ? formBL?.expenses_propotion - sumExpensesInvestSaving
      : 0;
    if (expenseValue > salaryValue / 2) {
      return "normal";
    } else {
      return "good";
    }
  };
  const checkOutcomeTitle = () => {
    const status = checkResultExpenses();
    if (status === "normal") {
      return (
        <div className=" bg-yellowopacity text-mainyellow  px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          พอใช้
        </div>
      );
    }
    if (status === "good") {
      return (
        <div className="bg-greenopacity text-maingreen px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          ยอดเยี่ยม
        </div>
      );
    }
  };
  const checkOutcomeIcon = () => {
    const status = checkResultExpenses();
    if (status === "normal") {
      return "/images/medium_finance.svg";
    }
    if (status === "good") {
      return "/images/happy_finance.svg";
    }
  };
  const checkOutcomeSubtitle = (formBL) => {
    const status = checkResultExpenses();
    // รายรับ
    const salaryValue = formBL?.salary_propotion ? formBL?.salary_propotion : 0;

    // ค่าใช้จ่ายการออมและลงทุน
    const sumExpensesInvestSaving = formBL?.sum_expenses_invest_saving
      ? formBL?.sum_expenses_invest_saving
      : 0;

    // รายจ่ายที่ไม่รวมค่าใช้จ่ายเพื่อการออม

    const expenseValue = formBL?.expenses_propotion
      ? formBL?.expenses_propotion - sumExpensesInvestSaving
      : 0;

    // formBL?.expenses_propotion > sumExpensesInvestSaving
    //   ? formBL?.expenses_propotion - sumExpensesInvestSaving
    //   : formBL?.expenses_propotion;

    // หาเปอร์เซ็นรายจ่ายต่อรายรับ
    const expensesPerSalary = ((expenseValue / salaryValue) * 100)?.toFixed(2);

    if (status === "normal") {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-mainyellow">
          คุณมีรายจ่ายรวม{" "}
          <span className=" font-semibold ">
            {numeral(expenseValue)?.format("0,0")}
          </span>{" "}
          บาท
          <div>
            หรือ{" "}
            {String(expensesPerSalary) === "Infinity" ? 0 : expensesPerSalary} %
            ซึ่งมากกว่าครึ่งนึงของรายรับ{" "}
          </div>
        </div>
      );
    }
    if (status === "good") {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-maingreen">
          คุณมีรายจ่ายรวม{" "}
          <span className=" font-semibold ">
            {numeral(expenseValue)?.format("0,0")}
          </span>{" "}
          บาท
          <div>หรือ {expensesPerSalary} % ซึ่งน้อยกว่าครึ่งนึงของรายรับ </div>
        </div>
      );
    }
  };
  const checkOutcomeDes = () => {
    const status = checkResultExpenses();
    //รายรับ
    const salaryValue = formBL?.salary_propotion ? formBL?.salary_propotion : 0;

    // ค่าใช้จ่ายการออมและลงทุน
    const sumExpensesInvestSaving = formBL?.sum_expenses_invest_saving
      ? formBL?.sum_expenses_invest_saving
      : 0;
    // รายจ่ายที่ไม่รวมค่าใช้จ่ายเพื่อการออม
    const expenseValue = formBL?.expenses_propotion
      ? formBL?.expenses_propotion - sumExpensesInvestSaving
      : 0;

    // formBL?.expenses_propotion > sumExpensesInvestSaving
    //   ? formBL?.expenses_propotion - sumExpensesInvestSaving
    //   : formBL?.expenses_propotion;

    // ลดค่าใช้จ่าย
    const reduceExpense = expenseValue - salaryValue / 2;

    if (status === "normal") {
      return (
        <div>
          คุณควรประหยัดและลดค่าใช้จ่าย{" "}
          <span className=" text-mainblue font-bold">
            {numeral(reduceExpense).format("0,0")} บาท
          </span>
          <div>เพื่อให้บรรลุเป้าหมายทางการเงินของคุณ</div>
          <div className=" text-maingray text-sm mt-3">
            *รายรับ{" "}
            <span className=" text-mainblue font-bold">
              {numeral(salaryValue)?.format("0,0")} บาท
            </span>
            <div>
              ครึ่งหนึ่งของรายรับคือ{" "}
              <span className=" text-mainblue font-bold">
                {numeral(salaryValue / 2)?.format("0,0")} บาท
              </span>
            </div>
          </div>
        </div>
      );
    }
    if (status === "good") {
      return (
        <div>
          คุณมีการใช้จ่ายในสัดส่วนที่ดี
          <div className=" text-maingray text-sm mt-3">
            *รายรับ{" "}
            <span className=" text-mainblue font-bold">
              {numeral(salaryValue)?.format("0,0")} บาท
            </span>
            <div>
              ครึ่งหนึ่งของรายรับคือ{" "}
              <span className=" text-mainblue font-bold">
                {numeral(salaryValue / 2)?.format("0,0")} บาท
              </span>
            </div>
          </div>
        </div>
      );
    }
  };

  //======================================== สภาพคล่องพื้นฐาน ========================================//
  const {
    liquidAssets,
    annualFixedAndVariableExpense,
    monthlyExpense,
    targetLiquidAssets,
    reserveDifference,
    ratio: basicLiquidityRatio,
    status: basicLiquidityStatus,
  } = calculateBasicLiquidityRatio({ balanceData: formBL });
  const checkProperty = basicLiquidityRatio;

  const checkResultProperty = () => basicLiquidityStatus;
  const checkPropertyIcon = () => {
    const status = checkResultProperty();
    if (status === "bad") {
      return "/images/bad_finance.svg";
    }
    if (status === "good") {
      return "/images/happy_finance.svg";
    }
    return "/images/chance_finance.svg";
  };
  const checkAmouthProperty = () => {
    const status = checkResultProperty();
    if (status === "bad") {
      return checkProperty;
    }
    if (status === "good") {
      return checkProperty;
    }
    return checkProperty;
  };

  const checkPropertyTitle = () => {
    const status = checkResultProperty();
    if (status === "bad") {
      return (
        <div className=" bg-[#FF0000]/30 text-[#FF0000]  px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          ปรับปรุง
        </div>
      );
    }
    if (status === "good") {
      return (
        <div className="bg-greenopacity text-maingreen px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          ยอดเยี่ยม
        </div>
      );
    }
    return (
      <div className="bg-yellowopacity text-mainyellow px-3 py-1 rounded-[6px] text-xl font-semibold w-fit text-center">
        เพิ่มโอกาส
      </div>
    );
  };
  // แสดงสมการจากสินทรัพย์และรายจ่ายต่อเดือนชุดเดียวกับ owner กลาง เพื่อให้รายละเอียดตรงกับอัตราส่วน
  const checkPropertySubtitle = () => {
    const status = checkResultProperty();
    const value = checkAmouthProperty();

    const MethodBox = ({ title, subtitle, des, icon, onClick }) => {
      return (
        <div className="">
          <div className=" text-maingray font-normal text-sm text-center">
            <span className=" font-semibold text-mainblue">
              อัตราส่วนสภาพคล่อง
            </span>{" "}
            = สินทรัพย์สภาพคล่อง/รายจ่ายต่อเดือน
          </div>
          <div className=" text-maingray text-xs text-center mt-1">
            ({" "}
            <span className=" text-mainblue font-semibold">
              {numeral(value)?.format("0[.]00")}
            </span>{" "}
            = {numeral(liquidAssets).format("0,0")} /{" "}
            {numeral(monthlyExpense).format("0,0")} )
          </div>
        </div>
      );
    };

    if (status === "bad") {
      return (
        <div className="text-lg font-semibold text-center my-2.5  text-[#FF0000]">
          คุณมีอัตราส่วนสภาพคล่อง {numeral(value)?.format("0[.]00")} เท่า
          ซึ่งน้อยกว่า 6 เท่า
          <MethodBox />
        </div>
      );
    }
    if (status === "good") {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-maingreen">
          คุณมีอัตราส่วนสภาพคล่องพื้นฐาน 6 เท่า
          <MethodBox />
        </div>
      );
    }
    return (
      <div className="text-lg font-semibold text-center my-2.5  text-mainyellow ">
        คุณมีอัตราส่วนสภาพคล่อง {numeral(value)?.format("0[.]00")} เท่า
        ซึ่งมากกว่า 6 เท่า
        <MethodBox />
      </div>
    );
  };
  // คำนวณเงินสำรองที่ขาดหรือเหลือจากรายจ่ายต่อเดือนของ owner กลาง โดยไม่รวมเงินออมหรือลงทุน
  const checkPropertyDes = () => {
    const status = checkResultProperty();
    const additionalReserveNeeded = Math.max(-reserveDifference, 0);
    const excessLiquidAssets = Math.max(reserveDifference, 0);

    if (status === "bad") {
      return (
        <div className=" mb-4 font-medium">
          คุณต้องหาเงินสำรองเพิ่มอีก
          <span className=" px-1 font-bold text-red-500 ">
            {numeral(additionalReserveNeeded).format("0,0")}
          </span>
          บาท*
          <div>เพื่อความไม่ประมาทในการวางแผนการเงิน</div>
          <div className=" text-sm text-maingray mt-4 font-normal ">
            * ค่าใช้จ่ายแต่ละเดือน x 6 - สินทรัพย์สภาพคล่อง
            <div className=" text-xs mt-1">
              (
              <span className=" text-mainblue font-semibold pl-1">
                {numeral(monthlyExpense).format("0,0")}
              </span>{" "}
              x 6 - {numeral(liquidAssets).format("0,0")} ={" "}
              {numeral(additionalReserveNeeded).format("0,0")} )
            </div>
          </div>
        </div>
      );
    }

    if (status === "good") {
      return (
        <div className=" mb-10">
          คุณมีความสามารถในการรับมือกับ
          <div>
            เหตุการณ์ไม่คาดฝันได้ดี เช่น ตกงาน อุบัติเหตุทำให้สูญเสียรายรับ
            เป็นต้น
          </div>
        </div>
      );
    }
    return (
      <div className="mb-4 font-medium">
        คุณมีเงินสำรองจำนวนมาก
        <div>
          จะดีกว่าไหมหากนำเงิน
          <span className=" px-1 font-bold text-mainyellow ">
            {numeral(excessLiquidAssets).format("0,0")}
          </span>
          บาท*
          <div> ไปลงทุนเพิ่มเติม เพื่อให้บรรลุเป้าหมายทางการเงิน</div>
        </div>
        <div className=" text-sm text-maingray mt-4 font-normal ">
          * สินทรัพย์สภาพคล่อง - 6เท่าของค่าใช้จ่ายแต่ละเดือน
          <div className=" text-xs mt-1">
            (
            <span className=" text-mainblue font-semibold pl-1">
              {numeral(liquidAssets).format("0,0")}
            </span>{" "}
            - {numeral(targetLiquidAssets).format("0,0")} ={" "}
            {numeral(excessLiquidAssets).format("0,0")} )
          </div>
        </div>
      </div>
    );
  };

  //======================================== หนี้สินต่อสินทรัพย์ ========================================//
  const { totalAssets: debtToTotalAssetsDenominator, ratio: getDebttoTotalAsset } =
    useMemo(
      () =>
        calculateDebtToTotalAssets({
          balanceData,
          addInvest,
          returnInsurance: ReturnInsurance,
        }),
      [balanceData, addInvest, ReturnInsurance]
    );
  const checkDebttoAssetIcon = () => {
    const status = getDebttoTotalAsset;
    if (status > 50) {
      return "/images/bad_finance.svg";
    } else {
      return "/images/happy_finance.svg";
    }
  };
  const checkDebttoAssetTitle = () => {
    const status = getDebttoTotalAsset;
    if (status > 50) {
      return (
        <div className=" bg-[#FF0000]/30 text-[#FF0000]  px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          ปรับปรุง
        </div>
      );
    } else {
      return (
        <div className="bg-greenopacity text-maingreen px-3 py-1 rounded-[6px] text-xl font-semibold w-[150px] text-center">
          อยู่ในเกณฑ์
        </div>
      );
    }
  };
  const checkDebttoAssetSubtitle = () => {
    const status = getDebttoTotalAsset;
    if (status > 50) {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-[#FF0000]">
          คุณมีอัตราส่วนหนี้สินต่อสินทรัพย์ {getDebttoTotalAsset?.toFixed(2)} %
          <div>ซึ่งมากกว่า 50%</div>
        </div>
      );
    } else {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-maingreen">
          คุณมีอัตราส่วนหนี้สินต่อสินทรัพย์ {getDebttoTotalAsset?.toFixed(2)}%
          <div>ซึ่งน้อยกว่า 50% </div>
        </div>
      );
    }
  };
  const checkDebttoAssetDes = () => {
    const status = getDebttoTotalAsset;

    if (status > 50) {
      return (
        <div>
          ภาระหนี้สินมากเกินไป
          <div>โดยหาทางเพิ่มรายรับ ลดรายจ่ายที่ไม่จำเป็น</div>
          <div className=" text-maingray text-sm mt-3">
            <span className=" text-mainblue font-semibold">
              อัตราส่วนหนี้สินต่อสินทรัพย์ =
            </span>{" "}
            (หนี้สิน/สินทรัพย์)x100
            <div className=" text-xs mt-1">
              <span className=" text-mainblue font-bold">
                {getDebttoTotalAsset?.toFixed(2)} % =
              </span>{" "}
              (( {numeral(formBL?.debt_propotion)?.format("0,0")} /{" "}
              {numeral(debtToTotalAssetsDenominator)?.format("0,0")}) * 100 )
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          คุณมีอัตราส่วนหนี้สินต่อสินทรัพย์ในสัดส่วนที่ดี
          <div className=" text-maingray text-sm mt-3">
            <span className=" text-mainblue font-semibold">
              อัตราส่วนหนี้สินต่อสินทรัพย์ =
            </span>{" "}
            (หนี้สิน/สินทรัพย์)x100
            <div className=" text-xs mt-1">
              <span className=" text-mainblue font-bold">
                {getDebttoTotalAsset?.toFixed(2)} % =
              </span>{" "}
              (( {numeral(formBL?.debt_propotion)?.format("0,0")} /{" "}
              {numeral(debtToTotalAssetsDenominator)?.format("0,0")}) * 100 )
            </div>
          </div>
        </div>
      );
    }
  };

  //======================================== ชำระหนี้สินต่อรายรับ ========================================//
  const getDebttoSalary = useMemo(() => {
    let sum = 0;
    
    const debtPermonth =
      formBL?.sum_debt_short_permonth + formBL?.sum_debt_long_permonth;
    const salaryPermonth = formBL?.salary_propotion
      ? formBL?.salary_propotion / 12
      : 0;
    sum = salaryPermonth > 0 ? (debtPermonth / salaryPermonth) * 100 : 0;
    return sum;
  });
  const checkDebttoSalaryIcon = () => {
    const status = getDebttoSalary;
    if (status > 50) {
      return "/images/bad_finance.svg";
    } else {
      return "/images/happy_finance.svg";
    }
  };
  const checkDebttoSalaryTitle = () => {
    const status = getDebttoSalary;
    if (status > 50) {
      return (
        <div className=" bg-[#FF0000]/30 text-[#FF0000]  px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          ปรับปรุง
        </div>
      );
    } else {
      return (
        <div className="bg-greenopacity text-maingreen px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          ยอดเยี่ยม
        </div>
      );
    }
  };
  const checkDebttoSalarySubtitle = () => {
    const status = getDebttoSalary;
    if (status > 50) {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-[#FF0000]">
          คุณมีอัตราส่วนการชำระหนี้ต่อต่อรายรับ {getDebttoSalary?.toFixed(2)} %
          ซึ่งมากกว่า 50% *
        </div>
      );
    } else {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-maingreen">
          คุณมีอัตราส่วนการชำระหนี้ต่อต่อรายรับ {getDebttoSalary?.toFixed(2)} %
          ซึ่งน้อยกว่า 35% - 50% *
        </div>
      );
    }
  };
  const checkDebttoSalaryDes = () => {
    const status = getDebttoSalary;
    const salary_propotion_per_month = formBL?.salary_propotion / 12;

    if (status > 50) {
      return (
        <div>
          ควรวางแผนบริหารหนี้เช่น หาทางเพิ่มรายรับ ลดรายจ่ายไม่จำเป็น
          รักษาสภาพคล่อง
          <div className=" text-maingray text-sm mt-3">
            <span className=" text-mainblue font-semibold pr-1">
              อัตราส่วนการชำระหนี้ต่อรายรับ =
            </span>
            (เงินชำระหนี้สินต่อเดือน/รายรับต่อเดือน)x100
            <div className=" text-xs mt-1">
              <span className=" text-mainblue font-bold">
                {getDebttoSalary?.toFixed(2)} % =
              </span>{" "}
              ({" "}
              {numeral(
                formBL?.sum_debt_short_permonth + formBL?.sum_debt_long_permonth
              ).format("0,0")}{" "}
              / {numeral(salary_propotion_per_month).format("0,0")} * 100 )
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          ภาระหนี้สินไม่มากเกิน หนี้สินที่ดีก่อให้เกิดรายรับและ สินทรัพย์ในอนาคต
          <div className=" text-maingray text-sm mt-3">
            <span className=" text-mainblue font-semibold pr-1">
              อัตราส่วนการชำระหนี้ต่อรายรับ =
            </span>
            (เงินชำระหนี้สินต่อเดือน/รายรับต่อเดือน)x100
            <div className=" text-xs mt-1">
              ({" "}
              <span className=" text-mainblue font-bold">
                {getDebttoSalary?.toFixed(2)} % =
              </span>{" "}
              {numeral(
                formBL?.sum_debt_short_permonth + formBL?.sum_debt_long_permonth
              ).format("0,0")}{" "}
              / {numeral(salary_propotion_per_month).format("0,0")} * 100 )
            </div>
          </div>
        </div>
      );
    }
  };

  //======================================== การออม ========================================//
  const getConservation = useMemo(() => {
    let sum = 0;
    if (formBL?.sum_expenses_invest_saving) {
      sum = formBL?.sum_expenses_invest_saving;
    }
    const finalResult = sum > 0 ? (sum / formBL?.salary_propotion) * 100 : 0;
    return finalResult;
  });
  const getInvestSavingMore = useMemo(() => {
    // หาเปอเซ็นคงเหลือการออมใน 10%
    const salaryValue = formBL?.salary_propotion ? formBL?.salary_propotion : 0;
    const sumExpensesInvestSaving = formBL?.sum_expenses_invest_saving
      ? formBL?.sum_expenses_invest_saving
      : 0;
    const conservation = (salaryValue * 10) / 100;
    const result = conservation - sumExpensesInvestSaving;
    return result;
  });
  const checkConservationIcon = () => {
    const status = getConservation;
    if (status > 10) {
      return "/images/happy_finance.svg";
    } else {
      return "/images/bad_finance.svg";
    }
  };
  const checkConservationTitle = () => {
    const status = getConservation;
    if (status > 10) {
      return (
        <div className="bg-greenopacity text-maingreen px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          ยอดเยี่ยม
        </div>
      );
    } else {
      return (
        <div className=" bg-[#FF0000]/30 text-[#FF0000]  px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          ปรับปรุง
        </div>
      );
    }
  };
  const checkConservationSubtitle = () => {
    const status = getConservation;

    if (status > 10) {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-maingreen">
          คุณมีอัตราส่วนการออม{" "}
          {numeral(formBL?.sum_expenses_invest_saving).format("0,0")} บาท หรือ{" "}
          {getConservation?.toFixed(2)} % ซึ่งมากกว่า 10 % *
        </div>
      );
    } else {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-[#FF0000]">
          คุณมีอัตราส่วนการออม
          {numeral(formBL?.sum_expenses_invest_saving).format("0,0.00")} บาท
          หรือ {getConservation?.toFixed(2)} % ซึ่งน้อยกว่า 10 % *
        </div>
      );
    }
  };
  const checkConservationDes = () => {
    const status = getConservation;
    const salaryValue = formBL?.salary_propotion ? formBL?.salary_propotion : 0;
    const salaryValuePercent = (salaryValue * 10) / 100;

    if (status > 10) {
      return (
        <div>
          คุณมีอัตราส่วนการออมและการลงทุนในสัดส่วนที่ดี
          <div className=" text-maingray text-sm mt-3">
            <div className="font-semibold"> อัตราส่วนการออม = </div>
            <div className=" mb-1">
              (ค่าใช้จ่ายเพื่อการออมและการลงทุน/รายรับรวม) x 100 *รายรับ{" "}
            </div>

            <span className=" text-mainblue font-bold">
              {numeral(salaryValue)?.format("0,0")} บาท
            </span>
            <div>
              10% ของรายรับคือ{" "}
              <span className=" text-mainblue font-bold">
                {numeral(salaryValuePercent)?.format("0,0")} บาท
              </span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          คุณควรเพิ่มการออมอีก{" "}
          <span className=" font-bold text-red-500 ">
            {numeral(getInvestSavingMore).format("0,0.00")}
          </span>{" "}
          บาท
          <div className="font-semibold"> อัตราส่วนการออม = </div>
          <div className=" mb-1">
            (ค่าใช้จ่ายเพื่อการออมและการลงทุน/รายรับรวม) x 100 *รายรับ{" "}
          </div>
          <div className=" text-maingray text-sm mt-3">
            *รายรับ{" "}
            <span className=" text-mainblue font-bold">
              {numeral(salaryValue)?.format("0,0")} บาท
            </span>
            <div>
              10% ของรายรับคือ{" "}
              <span className=" text-mainblue font-bold">
                {numeral(salaryValuePercent)?.format("0,0")} บาท
              </span>
            </div>
          </div>
        </div>
      );
    }
  };

  //======================================== การลงทุน ========================================//
  const getInvest = useMemo(() => {
    let sum = 0;
    if (
      SumDebtPersonalValue(balanceData) +
        sumCapitalInvest(addInvest, ReturnInsurance) +
        sumDebtInvest(balanceData) >
      0
    ) {
      sum =
        formBL?.net_wealth > 0
          ? ((SumDebtPersonalValue(balanceData) +
              sumCapitalInvest(addInvest, ReturnInsurance) +
              sumDebtInvest(balanceData)) /
              formBL?.net_wealth) *
            100
          : 0;
    }
    return sum;
  }, [balanceData, addInvest, ReturnInsurance, formBL?.net_wealth]);

  const checkInvestIcon = () => {
    const status = getInvest;
    if (status > 50) {
      return "/images/happy_finance.svg";
    } else {
      return "/images/bad_finance.svg";
    }
  };
  const checkInvestTitle = () => {
    const status = getInvest;
    if (status > 50) {
      return (
        <div className="bg-greenopacity text-maingreen px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          ยอดเยี่ยม
        </div>
      );
    } else {
      return (
        <div className=" bg-[#FF0000]/30 text-[#FF0000]  px-3 py-1 rounded-[6px] text-xl font-semibold w-[108px] text-center">
          ปรับปรุง
        </div>
      );
    }
  };
  const checkInvestSubtitle = () => {
    const status = getInvest;

    const MethodBox = ({ value }) => {
      return (
        <div className="">
          <div className=" text-maingray font-normal text-sm text-center">
            <span className=" font-semibold text-mainblue">
              อัตราส่วนการลงทุน
            </span>{" "}
            = (สินทรัพย์ลงทุน/ความมั่งคั่งสุทธิ) x 100
          </div>
          <div className=" text-maingray text-xs text-center mt-1">
            ( <span className=" text-mainblue font-semibold">{value}</span> =
            &nbsp;
            {numeral(
              SumDebtPersonalValue(balanceData) +
                sumCapitalInvest(addInvest, ReturnInsurance) +
                sumDebtInvest(balanceData)
            ).format("0,0")}{" "}
            / {numeral(formBL?.net_wealth).format("0,0")} * 100 )
          </div>
        </div>
      );
    };

    if (status > 50) {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-maingreen">
          คุณมีอัตราส่วนการลงทุน {getInvest?.toFixed(2)} %
          <div>ซึ่งมากกว่า 50 %</div>
          <MethodBox value={getInvest?.toFixed(2)} />
        </div>
      );
    } else {
      return (
        <div className="text-xl font-semibold text-center my-2.5  text-[#FF0000]">
          คุณมีอัตราส่วนการลงทุน {getInvest?.toFixed(2)} %
          <div>ซึ่งน้อยกว่า 50 %</div>
          <MethodBox value={getInvest?.toFixed(2)} />
        </div>
      );
    }
  };
  const checkInvestDes = () => {
    const status = getInvest;
    if (status > 50) {
      return (
        <div>
          คุณมีแนวโน้มที่จะบรรลุเป้าหมายการเงินที่ต้องการ
          จัดสรรการลงทุนให้เหมาะสมกับลำดับความสำคัญ
        </div>
      );
    } else {
      return (
        <div>
          คุณมีสินทรัพย์ที่ก่อให้เกิดรายรับน้อยเกินไป
          ควรจัดสรรการลงทุนเพิ่มพูนมั่งคั่ง
        </div>
      );
    }
  };

  return (
    <div className="bg-gray50 rounded-[20px] p-4 font-IBMPlexSansThai">
      <Accordion
        animate={{
          transition: "all .100s ease-in-out",
          height: "auto",
          overflow: "hidden",
        }}
        open={open}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 17 16"
            className={`${
              open ? "" : "rotate-180"
            } transition-transform h-4 w-4`}
            fill="none"
          >
            <path
              d="M3.83366 10L8.50033 5.33336L13.167 10"
              stroke="#919191"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
        className="group"
      >
        <AccordionHeader
          className={` border-b-0 transition-colors text-md text-gray-800 font-IBMPlexSansThai font-medium w-full p-0 `}
          onClick={onClick}
        >
          <div className=" font-semibold">{open ? "" : "วิเคราะห์การเงิน"}</div>
        </AccordionHeader>
        <AccordionBody className="p-0 ">
          <div className=" space-y-5">
            <div className=" ">
              <div className={STYLE_TITLE_SUM_NETFLOW}>
                <ImageMain
                  src="/images/income_insuarance_all.png"
                  className=" w-8 h-8"
                />
                รายรับและรายจ่าย
              </div>
              <div className={STYLE_SPACE_SUM_NETFLOW}>
                <CardFinancialResult
                  openInfo={() => {
                    setOpenInfoSumFinancial("income");
                  }}
                  title={`รายรับ`}
                  value={formBL?.salary_propotion ? true : false}
                  status={getResult()}
                  openPopup={() =>
                    setOpenPopupIncome(formBL?.salary_propotion ? true : false)
                  }
                />
                <CardFinancialResult
                  openInfo={() => {
                    setOpenInfoSumFinancial("outcome");
                  }}
                  title={`รายจ่าย`}
                  value={
                    formBL?.expenses_propotion -
                    formBL?.sum_expenses_invest_saving
                      ? true
                      : false
                  }
                  status={checkResultExpenses()}
                  openPopup={() =>
                    setOpenPopupOutcome(
                      formBL?.expenses_propotion ? true : false
                    )
                  }
                />
              </div>
            </div>
            <div>
              <div className={STYLE_TITLE_SUM_NETFLOW}>
                <ImageMain
                  src="/images/invest_insuarance_all.png"
                  className=" w-8 h-8"
                />
                สรุปอัตราส่วนทางการเงิน
              </div>
              <div className={STYLE_SPACE_SUM_NETFLOW}>
                <CardFinancialResult
                  openInfo={() => {
                    setOpenInfoSumFinancial("property");
                  }}
                  title={`อัตราส่วนสภาพคล่องพื้นฐาน `}
                  value={
                    liquidAssets && annualFixedAndVariableExpense
                      ? true
                      : false
                  }
                  status={checkResultProperty()}
                  amount={`${numeral(checkAmouthProperty())?.format(
                    "0[.]00"
                  )} เท่า`}
                  // amount={`1111 เท่า`}
                  openPopup={() =>
                    setOpenPopupProperty(
                      liquidAssets && annualFixedAndVariableExpense
                        ? true
                        : false
                    )
                  }
                />
                <CardFinancialResult
                  openInfo={() => {
                    setOpenInfoSumFinancial("debt_to_asset");
                  }}
                  title={`อัตราส่วนหนี้สินต่อสินทรัพย์`}
                  value={
                    formBL?.debt_propotion && debtToTotalAssetsDenominator
                      ? true
                      : false
                  }
                  status={getDebttoTotalAsset > 50 ? "bad" : "good"}
                  amount={` ${getDebttoTotalAsset?.toFixed(2)} %`}
                  openPopup={() =>
                    setOpenPopupDebtToAsset(
                      formBL?.debt_propotion && debtToTotalAssetsDenominator
                        ? true
                        : false
                    )
                  }
                />
                <CardFinancialResult
                  openInfo={() => {
                    setOpenInfoSumFinancial("debt_to_salary");
                  }}
                  title={
                    <div>
                      อัตราส่วนการชำระหนี้
                      <div>ต่อรายรับ</div>
                    </div>
                  }
                  value={
                    formBL?.debt_propotion && formBL?.salary_propotion
                      ? true
                      : false
                  }
                  status={getDebttoSalary > 50 ? "bad" : "good_2"}
                  amount={`${getDebttoSalary?.toFixed(2)} %`}
                  openPopup={() =>
                    setOpenPopupDebtToSalary(
                      formBL?.debt_propotion && formBL?.salary_propotion
                        ? true
                        : false
                    )
                  }
                />
                <CardFinancialResult
                  openInfo={() => {
                    setOpenInfoSumFinancial("conservation");
                  }}
                  title={`อัตราส่วนการออม`}
                  value={
                    formBL?.salary_propotion && formBL?.expenses_propotion
                      ? true
                      : false
                  }
                  status={getConservation > 10 ? "good" : "bad"}
                  amount={`${getConservation?.toFixed(2)}  %`}
                  openPopup={() =>
                    setOpenPopupConservation(
                      formBL?.salary_propotion && formBL?.expenses_propotion
                        ? true
                        : false
                    )
                  }
                />
                <CardFinancialResult
                  openInfo={() => {
                    setOpenInfoSumFinancial("invest");
                  }}
                  title={`อัตราส่วนการลงทุน `}
                  value={
                    SumDebtPersonalValue(balanceData) +
                      sumCapitalInvest(addInvest, ReturnInsurance) +
                      sumDebtInvest(balanceData) >
                      0 && balanceData?.net_wealth
                      ? true
                      : false
                  }
                  status={getInvest > 50 ? "good" : "bad"}
                  amount={`${getInvest?.toFixed(2)} %`}
                  openPopup={() =>
                    setOpenPopupInvest(
                      SumDebtPersonalValue(balanceData) +
                        sumCapitalInvest(addInvest, ReturnInsurance) +
                        sumDebtInvest(balanceData) >
                        0 && balanceData?.net_wealth
                        ? true
                        : false
                    )
                  }
                />
              </div>
            </div>
          </div>
        </AccordionBody>
      </Accordion>

      {/*============================== Popup ==============================*/}
      {openPopupIncome && (
        <PopupBalanceMain
          icon={checkIncomeIcon()}
          open={openPopupIncome}
          onClose={() => {
            setOpenPopupIncome(false);
          }}
          head={checkIncomeTitle()}
          subtitle={checkIncomeSubtitle()}
          discription={checkIncomeDes()}
        />
      )}

      {openInfoSumFinancial === "income" && (
        <InfoDrawer
          bottom="bottom-[-60%]"
          head={"รายรับ"}
          text={
            <div className=" space-y-2">
              <li>
                รายรับ หมายถึง ผลตอบแทนที่ได้รับจากการทำงานหรืออื่น ๆ เช่น
                ดอกเบี้ย การลงทุน เป็นต้น
              </li>
              <li>
                เกณฑ์พอใช้ หมายถึง
                มีช่องทางรายรับเพียงช่องทางเดียวซึ่งอาจจะไม่เหมาะกับสถานการณ์เศรษฐกิจปัจจุบัน
                เช่น การระบาดของโรคโควิด19
              </li>
              <li>
                เกณฑ์ยอดเยี่ยม หมายถึง มีช่องทางรายรับมากกว่า 1
                ช่องทางซึ่งเป็นเรื่องที่ดีสำหรับสถานการณ์ปัจจุบัน
              </li>
            </div>
          }
          open={openInfoSumFinancial === "income"}
          onClose={() => {
            setOpenInfoSumFinancial(false);
          }}
        />
      )}

      {openPopupOutcome && (
        <PopupBalanceMain
          padding="px-4"
          icon={checkOutcomeIcon()}
          open={openPopupOutcome}
          onClose={() => {
            setOpenPopupOutcome(false);
          }}
          head={checkOutcomeTitle()}
          subtitle={checkOutcomeSubtitle(formBL)}
          discription={checkOutcomeDes()}
        />
      )}

      {openInfoSumFinancial === "outcome" && (
        <InfoDrawer
          bottom="bottom-[-50%]"
          head={"รายจ่าย"}
          text={
            <div className=" space-y-2">
              <li>
                รายจ่าย หมายถึง มูลค่าเงินที่ใช้เป็นค่าอุปโภค
                บริโภคเมื่อทำกิจกรรมใด ๆ ในโปรแกรมนี้หมายถึง
                รายจ่ายคงที่และรายจ่ายผันแปร
              </li>
              <li>
                เกณฑ์ยอดเยี่ยม หมายถึง มีค่าใช้จ่ายไม่เกินร้อยละ 50 ของรายรับ
                เช่น รายรับ 1,000,000 บาท/ปี รายจ่าย 400,000 บาท/ปี
              </li>
              <li>
                เกณฑ์พอใช้ หมายถึง มีค่าใช้จ่ายเกินร้อยละ 50 ของรายรับ เช่น
                รายรับ 1,000,000 บาท/ปี รายจ่าย 990,000 บาท/ปี
              </li>
            </div>
          }
          open={openInfoSumFinancial === "outcome"}
          onClose={() => {
            setOpenInfoSumFinancial(false);
          }}
        />
      )}

      {openPopupProperty && (
        <PopupBalanceMain
          padding="px-4"
          icon={checkPropertyIcon()}
          open={openPopupProperty}
          onClose={() => {
            setOpenPopupProperty(false);
          }}
          head={checkPropertyTitle()}
          subtitle={checkPropertySubtitle()}
          discription={checkPropertyDes()}
        />
      )}

      {openInfoSumFinancial === "property" && (
        <InfoDrawer
          bottom="bottom-[-60%]"
          fontHead="text-2xl"
          head={"อัตราส่วนสภาพคล่องพื้นฐาน"}
          text={
            <div className=" space-y-2">
              <div>
                แสดงถึงสินทรัพย์สภาพคล่องที่มีอยู่ว่าสามารถใช้ในการดำรงชีวิตได้กี่เดือน
                แม้ว่าเราอาจจะไม่มีรายรับ ซึ่งอัตราส่วนนี้ควรมีค่า 6
                เท่าของค่าใช้จ่ายต่อเดือน
              </div>

              <div className={STYLE_BOXCAL_ETC}>
                <ImageMain
                  src="../images/lamp.png"
                  className=" w-4 h-4 absolute top-2  left-2"
                />
                <div className="font-semibold">
                  {" "}
                  อัตราส่วนสภาพคล่องพื้นฐาน ={" "}
                </div>
                สินทรัพย์สภาพคล่อง/ค่าใช้จ่ายต่อเดือน
              </div>
              <div className={STYLE_INFODRAWER_ETC}>
                <div>
                  ตัวอย่าง มีสินทรัพย์สภาคล่อง(เงินสด) 300,000 บาท
                  มีค่าใช้จ่ายต่อเดือน 50,000 บาท/เดือน
                </div>
                <div className="">
                  วิธีคิด 300,000/50,000{" "}
                  <span className=" text-mainblue font-semibold">= 6</span>
                </div>
                <div>
                  ดังนั้น สภาพคล่องพื้นฐานคือ 6 เท่า ซึ่งอยู่ในเกณฑ์ที่ดี
                </div>
              </div>
            </div>
          }
          open={openInfoSumFinancial === "property"}
          onClose={() => {
            setOpenInfoSumFinancial(false);
          }}
        />
      )}

      {openPopupDebtToAsset && (
        <PopupBalanceMain
          padding="px-4"
          icon={checkDebttoAssetIcon()}
          open={openPopupDebtToAsset}
          onClose={() => {
            setOpenPopupDebtToAsset(false);
          }}
          head={checkDebttoAssetTitle()}
          subtitle={checkDebttoAssetSubtitle()}
          discription={checkDebttoAssetDes()}
        />
      )}

      {openInfoSumFinancial === "debt_to_asset" && (
        <InfoDrawer
          bottom="bottom-[-80%]"
          head={"อัตราส่วนหนี้สินต่อสินทรัพย์ "}
          text={
            <div className=" space-y-2">
              <div>
                แสดงถึงปริมาณหนี้สินเมื่อเทียบกับสินทรัพย์ที่มี
                ซึ่งอัตราส่วนนี้ควรมีค่าน้อยกว่า 50%
              </div>
              <div className={STYLE_BOXCAL_ETC}>
                <ImageMain
                  src="../images/lamp.png"
                  className=" w-4 h-4 absolute top-2  left-2"
                />
                <div className="font-semibold">
                  {" "}
                  อัตราส่วนหนี้สินต่อสินทรัพย์ ={" "}
                </div>
                (หนี้สิน/สินทรัพย์)x100
              </div>

              <div className={STYLE_INFODRAWER_ETC}>
                <div>
                  {" "}
                  ตัวอย่าง มีหนี้สิน 70,000 บาท มีสินทรัพย์ 100,000 บาท
                </div>
                <div className=" mt-1">
                  วิธีคิด (70,000/100,000) x100 = 70 %
                </div>
                <div>
                  ดังนั้น หนี้สินต่อสินทรัพย์คือ 70 % ซึ่งอยู่ในเกณฑ์ที่ปรับปรุง
                </div>
              </div>
            </div>
          }
          open={openInfoSumFinancial === "debt_to_asset"}
          onClose={() => {
            setOpenInfoSumFinancial(false);
          }}
        />
      )}

      {openPopupDebtToSalary && (
        <PopupBalanceMain
          padding="px-4"
          icon={checkDebttoSalaryIcon()}
          open={openPopupDebtToSalary}
          onClose={() => {
            setOpenPopupDebtToSalary(false);
          }}
          head={checkDebttoSalaryTitle()}
          subtitle={checkDebttoSalarySubtitle()}
          discription={checkDebttoSalaryDes()}
        />
      )}

      {openInfoSumFinancial === "debt_to_salary" && (
        <InfoDrawer
          bottom="bottom-[-60%]"
          fontHead="text-2xl"
          head={"อัตราส่วนการชำระหนี้ต่อรายรับ "}
          text={
            <div className=" space-y-2">
              <div>
                แสดงถึงความสามารถในการชำระคืนหนี้สินจากรายรับรวมที่ได้รับ
                ซึ่งอัตราส่วนนี้ควรมีค่าระหว่าง 35% - 45% หากมีค่ามาก ๆ
                อาจมีความเสี่ยงเรื่องการผ่อนชำระหนี้ในอนาคต
              </div>
              <div className={STYLE_BOXCAL_ETC}>
                <ImageMain
                  src="../images/lamp.png"
                  className=" w-4 h-4 absolute top-2  left-2"
                />
                <div className="font-semibold">
                  {" "}
                  อัตราส่วนการชำระหนี้ต่อรายรับ ={" "}
                </div>
                (เงินชำระหนี้สินต่อเดือน/รายรับต่อเดือน)x100
              </div>
              <div className={STYLE_INFODRAWER_ETC}>
                <div>
                  {" "}
                  ตัวอย่าง มีเงินชำระหนี้ 40,000 บาท มีรายรับต่อเดือน 100,000
                  บาท/เดือน
                </div>
                <div className=" mt-1">
                  วิธีคิด (40,000/100,000) x100 = 40 %
                </div>
                <div>
                  ดังนั้น การชำระหนี้ต่อรายรับคือ 40% ซึ่งอยู่ในเกณฑ์ที่ดี
                </div>
              </div>
            </div>
          }
          open={openInfoSumFinancial === "debt_to_salary"}
          onClose={() => {
            setOpenInfoSumFinancial(false);
          }}
        />
      )}

      {openPopupConservation && (
        <PopupBalanceMain
          padding="px-4"
          icon={checkConservationIcon()}
          open={openPopupConservation}
          onClose={() => {
            setOpenPopupConservation(false);
          }}
          head={checkConservationTitle()}
          subtitle={checkConservationSubtitle()}
          discription={checkConservationDes()}
        />
      )}

      {openInfoSumFinancial === "conservation" && (
        <InfoDrawer
          bottom="bottom-[-60%]"
          head={"อัตราส่วนการออม"}
          text={
            <div className=" space-y-2">
              <div>
                แสดงถึงความสามารถในการออมเงินจากรายรับ
                เพื่อใช้สำหรับเป้าหมายทางการเงินในอนาคต เช่น ศึกษาต่อ ดาวน์บ้าน
                ซื้อรถ ท่องเที่ยว เกษียณ ฯลฯ
                ซึ่งอัตราส่วนนี้ควรมากกว่าหรือเท่ากับ 10%
              </div>

              <div className={STYLE_BOXCAL_ETC}>
                <ImageMain
                  src="../images/lamp.png"
                  className=" w-4 h-4 absolute top-2  left-2"
                />
                <div className="font-semibold"> อัตราส่วนการออม = </div>
                (ค่าใช้จ่ายเพื่อการออมและการลงทุน/รายรับรวม) x 100
              </div>
              <div className={STYLE_INFODRAWER_ETC}>
                <div>
                  ตัวอย่าง มีรายรับรวม 100,000 บาท
                  มีค่าใช้จ่ายเพื่อการออมและการลงทุน 30,000 บาท
                </div>
                <div className=" mt-1">
                  วิธีคิด (30,000 /100,000)x100 = 30 %
                </div>
                <div>
                  ดังนั้น มีการออมมากกว่า 10% ของรายรับ ซึ่งอยู่ในเกณฑ์ที่ดี
                </div>
              </div>
            </div>
          }
          open={openInfoSumFinancial === "conservation"}
          onClose={() => {
            setOpenInfoSumFinancial(false);
          }}
        />
      )}

      {openPopupInvest && (
        <PopupBalanceMain
          padding="px-4"
          icon={checkInvestIcon()}
          open={openPopupInvest}
          onClose={() => {
            setOpenPopupInvest(false);
          }}
          head={checkInvestTitle()}
          subtitle={checkInvestSubtitle()}
          discription={checkInvestDes()}
        />
      )}

      {openInfoSumFinancial === "invest" && (
        <InfoDrawer
          bottom="bottom-[-60%]"
          head={"อัตราส่วนการลงทุน"}
          text={
            <div className=" space-y-2">
              <div>
                แสดงถึงสถานภาพทางการเงินที่มีความมั่นคง
                ซึ่งอัตราส่วนนี้ควรมากกว่าหรือเท่ากับ 50%
              </div>

              <div className={STYLE_BOXCAL_ETC}>
                <ImageMain
                  src="../images/lamp.png"
                  className=" w-4 h-4 absolute top-2  left-2"
                />
                <div className="font-semibold"> อัตราส่วนการลงทุน = </div>
                (สินทรัพย์ลงทุน/ความมั่งคั่งสุทธิ) x 100
              </div>
              <div className={STYLE_INFODRAWER_ETC}>
                <div>
                  {" "}
                  ตัวอย่าง มีสินทรัพย์ลงทุน 300,000 บาท มีความมั่งคั่งสุทธิ
                  900,000 บาท
                </div>
                <div className=" mt-1">
                  วิธีคิด ( 300,000/900,000)x100 = 33.3 %
                </div>
                <div>ดังนั้น มีการลงทุน 33.33% ซึ่งอยู่ในเกณฑ์ที่ไม่ดี</div>
              </div>
            </div>
          }
          open={openInfoSumFinancial === "invest"}
          onClose={() => {
            setOpenInfoSumFinancial(false);
          }}
        />
      )}
    </div>
  );
};

export default SumFinancial;
